/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spoiler_ModeInputs */

const th_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ซ่อนผลการแข่งขัน`)
};

const en_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spoiler mode`)
};

const ja_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ネタバレ防止`)
};

const zh_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防剧透`)
};

const es_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo sin resultados`)
};

const pt_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modo sem spoiler`)
};

const id_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode tanpa bocoran`)
};

const fr_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mode sans spoiler`)
};

const tl_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang spoiler`)
};

const vi_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chế độ giấu kết quả`)
};

const ko_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`스포일러 방지`)
};

const de_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spoilerfrei`)
};

const ru_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без спойлеров`)
};

const tr_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sürpriz bozmaz`)
};

const it_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Senza spoiler`)
};

const pl_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez spoilerów`)
};

const uk_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Без спойлерів`)
};

const hi_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पॉइलर से बचाव`)
};

const ar_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بلا حرق للنتائج`)
};

const ms_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanpa bocoran`)
};

const bn_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফল ফাঁস নয়`)
};

const zh_tw2_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防劇透`)
};

const zh_hk2_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`防劇透`)
};

const ur_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`نتیجہ نہ بتائیں`)
};

const fa_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بدون لو دادن نتیجه`)
};

const sw_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bila kufichua matokeo`)
};

const nl_spoiler_mode = /** @type {(inputs: Spoiler_ModeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zonder spoilers`)
};

/**
* | output |
* | --- |
* | "Spoiler mode" |
*
* @param {Spoiler_ModeInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const spoiler_mode = /** @type {((inputs?: Spoiler_ModeInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spoiler_ModeInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_spoiler_mode(inputs)
	if (locale === "ja") return ja_spoiler_mode(inputs)
	if (locale === "zh") return zh_spoiler_mode(inputs)
	if (locale === "es") return es_spoiler_mode(inputs)
	if (locale === "pt") return pt_spoiler_mode(inputs)
	if (locale === "id") return id_spoiler_mode(inputs)
	if (locale === "fr") return fr_spoiler_mode(inputs)
	if (locale === "tl") return tl_spoiler_mode(inputs)
	if (locale === "vi") return vi_spoiler_mode(inputs)
	if (locale === "ko") return ko_spoiler_mode(inputs)
	if (locale === "de") return de_spoiler_mode(inputs)
	if (locale === "ru") return ru_spoiler_mode(inputs)
	if (locale === "tr") return tr_spoiler_mode(inputs)
	if (locale === "it") return it_spoiler_mode(inputs)
	if (locale === "pl") return pl_spoiler_mode(inputs)
	if (locale === "uk") return uk_spoiler_mode(inputs)
	if (locale === "hi") return hi_spoiler_mode(inputs)
	if (locale === "ar") return ar_spoiler_mode(inputs)
	if (locale === "ms") return ms_spoiler_mode(inputs)
	if (locale === "bn") return bn_spoiler_mode(inputs)
	if (locale === "zh-TW") return zh_tw2_spoiler_mode(inputs)
	if (locale === "zh-HK") return zh_hk2_spoiler_mode(inputs)
	if (locale === "ur") return ur_spoiler_mode(inputs)
	if (locale === "fa") return fa_spoiler_mode(inputs)
	if (locale === "sw") return sw_spoiler_mode(inputs)
	if (locale === "nl") return nl_spoiler_mode(inputs)
	return en_spoiler_mode(inputs)
});